import {
  SERVICES_ADD,
  SERVICES_LIST,
  SERVICES_UPDATE,
  SERVICES_DELETE,
  LOADING,
  NOT_FOUND,
} from "./type";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import axios from "axios";

export const ManageServiceList = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/services`, config);

    dispatch({
      type: SERVICES_LIST,
      payload: res.data,
    });
    if (res.data?.data?.shortedServices?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const addManageService = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    tooltip: val.tooltip,
    name: val.name,
    detail: val.detail,
    price: Number(val.price),
    subServeicePrice: Number(val.subServeicePrice),
    image: val.image == "undefined" ? "" : val.image,
    parentId: val.parentId == "" ? 0 : val.parentId,
  });

  try {
    const res = await axios.post(`${APIURL}/api/v1/services`, body, config);
    dispatch({ type: SERVICES_ADD, payload: res.data });
    toast.success("Service Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-service");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateManageService = (id, val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    tooltip: val.tooltip,
    name: val.name,
    detail: val.detail,
    price: val.price,
    subServeicePrice: val?.subServeicePrice,
    image: val.image == "undefined" ? "" : val.image,
    parentId: val.parentId,
  });

  try {
    const res = await axios.patch(
      `${APIURL}/api/v1/services/${id}`,
      body,
      config
    );
    dispatch({ type: SERVICES_UPDATE, payload: res.data });
    toast.success("Service Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-service");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const serviceDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete service?")) {
      const res = await axios.delete(`${APIURL}/api/v1/services/${id}`, config);
      dispatch({
        type: SERVICES_DELETE,
        payload: res.data,
      });
      toast.success("Service Deleted Successfully!");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

///
// export const multiServicesDelete = (id) => {
//   const token = localStorage.getItem("token");
//   var myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");
//   myHeaders.append("Authorization", `Bearer ${token}`);

//   var requestOptions = {
//     method: "DELETE",
//     headers: myHeaders,
//     redirect: "follow",
//   };
//   if (window.confirm("Do you want to delete select services?")) {
//     fetch(`${APIURL}/api/v1/services/multiServices/${id}`, requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         if (result?.status == "success") {
//           toast.success("services Deleted Successfully!");
//         }
//       })
//       .catch((error) => console.log("error", error));
//   }
// };
